import { useAuth } from './use-auth'

/**
 * `tenant_viewer` es read-only. Cualquier otro rol autenticado puede mutar
 * (super_admin, tenant_admin, tenant_manager).
 */
export function useCanWrite(): boolean {
  const { user } = useAuth()
  if (!user) return false
  return user.role !== 'tenant_viewer'
}

/**
 * Solo administradores del tenant o super_admin. Usar para configuración
 * del tenant (team, licencias, reglas).
 */
export function useIsAdmin(): boolean {
  const { user } = useAuth()
  if (!user) return false
  return user.role === 'tenant_admin' || user.role === 'super_admin'
}

export const roleLabels: Record<string, string> = {
  super_admin: 'Super Admin',
  tenant_admin: 'Admin',
  tenant_manager: 'Gestor',
  tenant_viewer: 'Visor',
}
